import * as actions from './GoalsSummaryActions';
import * as financialPlanActions from '../FinancialPlanActions';

const defaultState = {
  hasLoaded: false,
  goals: [],
  isGeneratingPDF: false,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case financialPlanActions.RECEIVE_DATA: {
      const { GoalsSummary, Goals } = action.data;

      const goals = GoalsSummary.map(summaryGoal => {
        const goal = Goals.find(({ GoalId }) => GoalId === summaryGoal.GoalId);

        return {
          ...summaryGoal,
          icon: goal.icon,
        };
      });

      return {
        ...state,
        hasLoaded: true,
        goals,
      };
    }

    case actions.CLEAR_GOALS_SUMMARY: {
      return defaultState;
    }

    default: {
      return state;
    }
  }
};
